import { useEffect, useState } from 'react'

// Minimal History-API router: one hook that returns the current pathname and
// re-renders on back/forward or on our own navigate() calls. Enough to give
// each nav page a real URL without pulling in a router library.

const NAVIGATE_EVENT = 'app:navigate'

export const getPathname = () => {
  try {
    return window.location.pathname || '/'
  } catch {
    return '/'
  }
}

export const navigate = (path, { replace = false } = {}) => {
  if (typeof window === 'undefined') return
  if (getPathname() === path) return
  try {
    if (replace) {
      window.history.replaceState(null, '', path)
    } else {
      window.history.pushState(null, '', path)
    }
    window.dispatchEvent(new Event(NAVIGATE_EVENT))
  } catch (error) {
    console.warn('Navigation failed:', error)
  }
}

export const usePathname = () => {
  const [pathname, setPathname] = useState(getPathname)

  useEffect(() => {
    const sync = () => setPathname(getPathname())
    window.addEventListener('popstate', sync)
    window.addEventListener(NAVIGATE_EVENT, sync)
    return () => {
      window.removeEventListener('popstate', sync)
      window.removeEventListener(NAVIGATE_EVENT, sync)
    }
  }, [])

  return pathname
}

// URL-safe slug for ids like "sunday:Sunday School:Room 1:sunday".
export const slugify = (value) =>
  String(value ?? '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
